export enum PublicDeveloperDetailsParams {
  developerUuid = "developerUuid",
}
